import DatabaseModel from './DatabaseModel.js';

var ItemTipoClasificacion = Object.create(DatabaseModel);

ItemTipoClasificacion.model = 'itemtipoclasificacion';
ItemTipoClasificacion.modelFront = 'itemtipoclasificacion';

export default ItemTipoClasificacion;
